import React, { useCallback, useContext, useState } from "react";
import { AppContext } from "../../../../../context/context";
import { Header } from "./MeetingDetails";
import { empType, Operation } from "../../../../../utils/Enum.types";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/DeleteRed.svg";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { CustomModal } from "../../../../../utils/UtilFunctions";
import {
  ViewAssetStylesRaiseTicket,
  ViewMoreFileStyles
} from "../../../../../styles/CustomModalStyles";
import AddMeetingNote from "./AddMeetingNote";
import {
  DeleteVendorNotesResult,
  DeleteVendorNotesVars,
  UpdateVendorNotesResult,
  UpdateVendorNotesVars,
  VendorNotes
} from "../queries/types";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";

import Pdf from "../../../../../images/DownloadPdf.svg";
import DownloadImage from "../../../../../images/DownloadImage.svg";
import Doc from "../../../../../images/WordDocument.svg";
import Xls from "../../../../../images/Excel.svg";
import { idAndFlagType } from "../../../../../utils/formTypes";
import {
  EMPTY_STRING,
  emptyIdAndModal,
  emptyMessage
} from "../../../../../utils/constants";
import { useMutation } from "@apollo/client";
import { DeleteVendorNotes, UpdateVendorNotes } from "../queries/mutations";
import { DeleteCategoryByIdVars } from "../../masters/category/queries/types";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { GetMomDetails, GetVendorNotes } from "../queries/query";
import MessageModal from "../../../../../customComponents/MessageModal";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { Button } from "../../../../../stories/Button/Button";
interface Props {
  vendorNotes: VendorNotes[];
}
const ViewNotes = ({ vendorNotes }: Props) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState<idAndFlagType>(emptyIdAndModal);

  const [message, setMessage] = useState(emptyMessage);
  const [deleteId, setDeleteId] = useState(0);

  const [DeleteNotes] = useMutation<
    DeleteVendorNotesResult,
    DeleteVendorNotesVars
  >(DeleteVendorNotes);
  const [attachmentId, setAttachmentId] = useState(0);
  const [vendorFilesModal, setVendorFilesModal] = useState(false);

  const [commentFiles, stCommentFiles] = useState<string[]>([]);

  const { user_details } = useLoggedInUserDetails();

  const { customer_id, momID, projectID } = useUrlParams();

  const downloadFile = (ext: string, index: number, commentId: number) => {
    const filename = `${customer_id}/momDetails/${momID}/${projectID}/vendorNotes/${commentId}_${index}.${ext}`;
    getDownloadUrl(filename, true);
  };

  const chooseFile = useCallback(
    (file: string, index: number, commentId: number) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({ image }: { image: string }) => {
        return (
          <div
            className="meeting-details--left--block--attachments--file"
            onClick={() => downloadFile(ext!, index, commentId)}
          >
            {file} <img src={image} alt="not found" />
          </div>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={DownloadImage} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );
  const chooseFileMore = useCallback(
    (file: string, index: number, commentId: number) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({ image }: { image: string }) => {
        return (
          <>
            <div
              className="meeting-details--left--block--attachments--file"
              onClick={() => downloadFile(ext!, index, commentId)}
            >
              <span> {file}</span> <img src={image} alt="not found" />
            </div>
          </>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={DownloadImage} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );
  const handleDelete = (id: number) => {
    try {
      if (customer_id) {
        setDeleteModal(!deleteModal);
        DeleteNotes({
          variables: {
            customerID: customer_id,
            user_details,
            momDetailsID: id
          },
          refetchQueries: [
            {
              query: GetVendorNotes,
              variables: {
                customerID: customer_id,
                momID,
                projectID,
                latest: true
              }
            }
          ]
        }).then(({ data }) => {
          if (data && data.DeleteVendorNotes) {
            setMessage({
              flag: true,
              message: `Comment deleted successfully`,
              operation: Operation.DELETE
            });
          }
        });
      }
    } catch (err) {
      console.error((err as Error).message);
    }
  };
  return (
    <div className="view-notes">
      <div className="view-notes__header">
        <b>Your Points in Minutes of Meeting</b>
        <div className="overall-total-count">
          Total Points : <b>{vendorNotes.length}</b>
        </div>
      </div>
      <div className="view-notes__block">
        <ul className="view-notes__block--header">
          {Header.filter((res) => res !== "Response").map((res, index) => {
            return <li key={index}>{res}</li>;
          })}
          <li>Actions</li>
        </ul>
        <div className="view-notes__block--sub">
          {vendorNotes.map((vendor_notes, index) => {
            let vendorFiles: string[] = [];
            let vendorVisibleFiles: string[] = [];
            let vendorRemainingCount = 0;

            if (vendor_notes.vendorNotesDocuments.trim() !== EMPTY_STRING) {
              vendorFiles = vendor_notes.vendorNotesDocuments.split(";");
              vendorVisibleFiles = vendorFiles.slice(0, 2);
              vendorRemainingCount = vendorFiles.length - 2;
            }

            return (
           
                <div className="view-notes__block--list" key={index}>
                  <span className="meeting-details--left--block--slno">
                    {index + 1} .
                  </span>
                  <div className="meeting-details--left--block--attachments">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: vendor_notes.vendorNotes
                      }}
                    />
                    <div>
                      {vendorVisibleFiles.map((file, i) => {
                        const filename = file.split("/").pop();
                        return (
                          <div key={i}>
                            {chooseFile(filename!, index, vendor_notes.id)}
                          </div>
                        );
                      })}
                      {vendorRemainingCount > 0 && (
                        <button
                          onClick={() => {
                            setAttachmentId(vendor_notes.id);
                            stCommentFiles(
                              vendor_notes.vendorNotesDocuments.split(";")
                            );
                            setVendorFilesModal(!vendorFilesModal);
                          }}
                        >
                          +{vendorRemainingCount} more
                        </button>
                      )}
                      <CustomModal
                        style={ViewMoreFileStyles}
                        isOpen={vendorFilesModal}
                        onRequestClose={() =>
                          setVendorFilesModal(!vendorFilesModal)
                        }
                        contentComponent={
                          <div className="meeting-details--left--block--more-files">
                            <div className="meeting-details--left--block--more-files-t">
                              <Title>Uploaded Files</Title>
                              <img
                                src={Close}
                                alt=""
                                onClick={() =>
                                  setVendorFilesModal(!vendorFilesModal)
                                }
                              />
                            </div>
                            <div className="meeting-details--left--block--more-files--block">
                              <ul>
                                {commentFiles.map((files, index) => {
                                  const filename = files.split("/").pop();

                                  return (
                                    <li key={index}>
                                      {chooseFileMore(
                                        filename!,
                                        index,
                                        attachmentId
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                            <Button
                              mode="cancel"
                              onClick={() =>
                                setVendorFilesModal(!vendorFilesModal)
                              }
                            />
                          </div>
                        }
                      />
                    </div>
                  </div>

                  <div>
                    <img
                      src={Edit}
                      alt=""
                      onClick={() => {
                        setEditModal({
                          flag: true,
                          id: vendor_notes.id
                        });
                      }}
                    />
                    <img
                      src={Delete}
                      alt=""
                      onClick={() => {
                        setDeleteId(vendor_notes.id);
                        setDeleteModal(!deleteModal);
                      }}
                    />
                  </div>
                </div>
            );
          })}
        </div>
      </div>
      <DeleteModal
        id={deleteId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />
      <CustomModal
        style={ViewAssetStylesRaiseTicket}
        isOpen={editModal.flag}
        onRequestClose={() => setEditModal(emptyIdAndModal)}
        contentComponent={
          <AddMeetingNote
            setModal={setEditModal}
            operation={Operation.UPDATE}
            idModalFlag={editModal}
          />
        }
      />

      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default ViewNotes;
